import React from 'react';
import propTypes from 'prop-types';
import PhoneNumberButton from 'tailwind-components/PhoneNumberButton/PhoneNumberButton';
import EmailButton from 'tailwind-components/EmailButton/EmailButton';

function ContactCard({ info, title }) {
  const isEmail = info && info.includes('@');

  return isEmail ? (
    <EmailButton text={info} label={title} />
  ) : (
    <PhoneNumberButton text={info} label={title} />
  );
}

ContactCard.propTypes = {
  title: propTypes.string,
  info: propTypes.string
};

export default ContactCard;
